import {
  addressScheme,
  requiredCustomSelectScheme,
  validateFullName,
} from '@sravni/cosago-react-library/lib/validationSchemes';
import { getValidationFields } from '@sravni/creditselection-customer-utils/lib/utils/customers';
import type { MixedSchema, ObjectSchema } from 'yup';
import { string, boolean, object } from 'yup';

import { FieldErrors } from 'shared/lib/fields';
import { differentFromFields, validateSurname } from 'shared/lib/validations';
import type { TDadataFullNameSuggest } from 'shared/types/TDaData';
import type { TFullData } from 'shared/types/TUserAddressFields';

import { validateFieldIfHasOtherOwner } from '../lib/validationFunctions';
import type { TPledgeEstateFields } from '../types';

const fields = getValidationFields();

export const PledgeEstateValidationSchema = (): ObjectSchema<TPledgeEstateFields> =>
  object({
    pledgeEstateAddress: addressScheme<TFullData>() as unknown as MixedSchema<
      TPledgeEstateFields['pledgeEstateAddress']
    >,
    isOnlyOwner: boolean<boolean>(),
    otherOwnerFullName: validateFieldIfHasOtherOwner(
      validateFullName<Dictionaries.TSelectValue<string, TDadataFullNameSuggest['data']>>({
        requiredNameError: FieldErrors.personName,
      }).test(validateSurname),
    ),
    otherOwnerPhone: validateFieldIfHasOtherOwner(
      fields.mobilePhone.test(differentFromFields(['mobilePhone', 'workPhone'], FieldErrors.phonesAreEqual)),
    ),
    otherOwnerMaritalStatus: validateFieldIfHasOtherOwner(requiredCustomSelectScheme()),
    relationship: validateFieldIfHasOtherOwner(requiredCustomSelectScheme()),
    pledgeEstateAddressFlat: validateFieldIfHasOtherOwner(string().optional()),
    isPledgeAddressSameRegistration: boolean<boolean>(),
  });
